import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaLightbulb, FaAward, FaUsers, FaHandHolding } from "react-icons/fa";
import "./Styles.css";

const values = [
  {
    icon: <FaLightbulb />,
    title: "Inspired",
    description:
      "We love to try new things that are connected to something greater.",
  },
  {
    icon: <FaAward />,
    title: "Authentic",
    description:
      "We are loyal to our company’s mission and values. We strive to be honest and as transparent as we can be.",
  },
  {
    icon: <FaHandHolding />,
    title: "Tenacious",
    description:
      "We never settle. We make sure that things get done regardless of how hard they seem to be.",
  },
  {
    icon: <FaUsers />,
    title: "Together",
    description:
      "We always look out for what our customer needs and together we will make sure that we deliver beyond our promises.",
  },
];

const ValuesSection = () => {
  return (
    <Container className="values-section text-center">
      <h2 className="mb-4">Our Values</h2>
      <Row>
        {values.map((value, index) => (
          <Col md={6} lg={3} key={index} className="value-item">
            <div className="icon">{value.icon}</div>
            <h4>{value.title}</h4>
            <p>{value.description}</p>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ValuesSection;
